import { usePrimaryPage, switchFeed } from '@/PageManager'
import { unwrappedFeedAtom } from '@/atoms/feed'
import BottomNavigationBarItem from './BottomNavigationBarItem'
import RelayIcon from '@/components/RelayIcon'
import { useResolvedHardcodedFeed } from '@/hooks/useResolvedHardcodedFeed'
import { useAtomValue } from 'jotai'

const MAX_VISIBLE = 4

export default function RelayFeedButton() {
  const feed = useAtomValue(unwrappedFeedAtom)

  const hardcoded = window.hallway.universe.hardcodedFeeds || []
  const visible = hardcoded.slice(0, MAX_VISIBLE)

  if (visible.length === 0) return null

  return (
    <>
      {visible.map((item, idx) => (
        <NavItem key={idx} item={item} index={idx} feed={feed} />
      ))}
    </>
  )
}

function NavItem({
  item,
  index,
  feed
}: {
  item: (typeof window.hallway.universe.hardcodedFeeds)[number]
  index: number
  feed: ReturnType<typeof useAtomValue<typeof unwrappedFeedAtom>>
}) {
  const { navigate, current, display } = usePrimaryPage()
  const { icon } = useResolvedHardcodedFeed(item)

  return (
    <BottomNavigationBarItem
      active={
        display &&
        current === 'home' &&
        !!feed &&
        'hardcodedFeed' in feed &&
        feed.hardcodedFeed === index
      }
      onClick={() => {
        navigate('home')
        switchFeed({ hardcodedFeed: index })
      }}
    >
      {icon ? (
        <img src={icon} className="w-5 h-5 object-cover object-center rounded" alt="" />
      ) : (
        <RelayIcon iconSize={16} className="w-5 h-5" />
      )}
    </BottomNavigationBarItem>
  )
}
